import React, { useState } from "react";
import { motion } from "framer-motion";
import CustomAction from "../../../../controls/CustomAction";
import urbanOption from "../../../../../Assets/urban-opt.png";
import jungleOption from "../../../../../Assets/jungle-opt.png";
import desertOption from "../../../../../Assets/desert-opt.png";
import coastalOption from "../../../../../Assets/coastal-opt.png";
import safariOption from "../../../../../Assets/safari-opt.png";
import otherOption from "../../../../../Assets/other-opt.png";
import { TbCircleDotFilled } from "react-icons/tb";
import Flag from "react-world-flags";

export default function EnvironmentType({
  mainColor,
  tripSelections,
  setTripSelections,
  handleNextStepPC,
  countryName,
  countryCode,
}) {
  const options = [
    {
      iconSrc: urbanOption,
      title: "Urban",
    },
    {
      iconSrc: jungleOption,
      title: "Jungle",
    },
    {
      iconSrc: desertOption,
      title: "Desert",
    },
    {
      iconSrc: coastalOption,
      title: "Coastal",
    },
    {
      iconSrc: safariOption,
      title: "Safari",
    },
    {
      iconSrc: otherOption,
      title: "Other",
    },
  ];

  const handleOptionsClick = (option) => {
    setTripSelections((prev) => {
      const existing = prev?.environmentType || [];
      const filtered = existing?.filter((item) => item.country !== countryName);
      return {
        ...prev,
        environmentType: [
          ...filtered,
          { country: countryName, option: option },
        ],
      };
    });
  };

  const handleContinue = () => {
    handleNextStepPC();
  };
  return (
    <motion.div
      initial={{ y: 50, opacity: 0 }}
      animate={{ y: 0, opacity: 1 }}
      transition={{ type: "spring", stiffness: 100, delay: 0.5 }}
      exit={{ y: 50, opacity: 0 }}
      className="bf-content-wrapper pc-trip-purpose"
    >
      <div className="bf-content-header">
        <h2 className="bf-title" style={{ color: mainColor }}>
          Environment Type for {countryName}
          <div className="flag-container">
            <Flag code={countryCode} />
          </div>
        </h2>
        <p className="bf-subtitle">
          Why we ask: Different locations come with different risks. Jungle
          areas may have mosquito-borne illnesses, while deserts can pose
          dehydration risks.
        </p>
      </div>

      <div className="bf-content-body">
        <div className="options-wrapper">
          {options.map((option) => {
            const isSelected = tripSelections?.environmentType?.some(
              (item) =>
                item.country === countryName && item.option === option.title
            );

            return (
              <div
                className={`option ${isSelected ? "selected" : ""}`}
                style={{
                  border: isSelected
                    ? `1px solid ${mainColor}`
                    : "1px solid #cecece",
                }}
                onClick={() => handleOptionsClick(option.title)}
                key={option.title}
              >
                <div className="icon-title">
                  <div>
                    <img src={option.iconSrc} alt="icon" />
                  </div>
                  <p>{option.title}</p>
                </div>

                {isSelected ? (
                  <TbCircleDotFilled
                    className="checkmark"
                    color={mainColor}
                    size={22}
                  />
                ) : (
                  <div className="empty-circle"></div>
                )}
              </div>
            );
          })}
        </div>
        <CustomAction mainColor={mainColor} text={"Continue"} action={handleContinue} />
      </div>
    </motion.div>
  );
}
